"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.executeRequest = exports.resourcesBaseOperations = exports.getAuthType = exports.isUrl = exports.replacePlaceholders = exports.prepareResources = exports.createHeaders = void 0;
const axios_1 = __importDefault(require("axios"));
// Object that maps the available token authorization types
const authorizationTypesMap = {
    bearer: 'Bearer',
    apikey: ''
};
// Function that creates and sets up the authorization header with local storage token
const createHeaders = (params = null, overrideAuthToken = null, disableAuth = false, customHeaders = [], responseType = null, tokenName = null, authType = 'bearer', signal = undefined) => {
    var _a;
    const token = tokenName ? ((_a = window === null || window === void 0 ? void 0 : window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem(tokenName)) || tokenName : tokenName;
    const headers = {
        headers: {}
    };
    if (signal) {
        headers.signal = signal;
    }
    if ((overrideAuthToken || token) && !disableAuth) {
        headers.headers.authorization = overrideAuthToken || `${(0, exports.getAuthType)(authType)} ${token}`.trim();
    }
    if (customHeaders && customHeaders.length > 0) {
        customHeaders.forEach(customHeader => {
            const { key, value } = customHeader || {};
            if (key && value) {
                headers.headers[key] = value;
            }
        });
    }
    if (params && typeof params === 'object' && !(params instanceof Array)) {
        headers.params = params;
    }
    if (responseType && typeof responseType === 'string') {
        headers.responseType = responseType;
    }
    return headers;
};
exports.createHeaders = createHeaders;
// Function that sets up the resources object from the init configuration
const prepareResources = ({ urlsConfig = {}, baseUrl = '', placeholders = {} }) => {
    const updatedUrls = Object.keys(urlsConfig).reduce((acc, key) => {
        let currentUrl = (0, exports.isUrl)(urlsConfig[key]) ? urlsConfig[key] : `${baseUrl}${urlsConfig[key]}`;
        if (placeholders) {
            // Check for placeholders in urls, if some are found, these will be replaced with the actual value
            currentUrl = (0, exports.replacePlaceholders)(currentUrl, placeholders);
        }
        acc[key] = currentUrl;
        return acc;
    }, {});
    return updatedUrls;
};
exports.prepareResources = prepareResources;
// Function with mapping placeholders object passed as argument, that switches placeholders with their actual values
const replacePlaceholders = (url, placeholders) => {
    if (url && placeholders) {
        const modifiedUrl = Object.keys(placeholders).reduce((acc, placeholder) => {
            if (url.includes(`/:${placeholder}`)) {
                acc = url.replace(`/:${placeholder}`, `${placeholders[placeholder]}`);
            }
            return acc;
        }, url);
        return modifiedUrl;
    }
    return '';
};
exports.replacePlaceholders = replacePlaceholders;
// Function to check if a string is a url
const isUrl = (text = null) => {
    return text && (text.startsWith('http://') || text.startsWith('https://'));
};
exports.isUrl = isUrl;
// Function that returns the correct authorization type based on the string passed as parameter
const getAuthType = (type) => {
    if (!type)
        return authorizationTypesMap.bearer;
    else if (authorizationTypesMap[type] === '')
        return '';
    return authorizationTypesMap[type] || authorizationTypesMap.bearer;
};
exports.getAuthType = getAuthType;
// function to setup initial parameters for every request
const resourcesBaseOperations = (resources, jwtToken, resource, authType, { responseType = null, params = null, auth = null, disableAuth = false, body = null, path = null, signal = undefined, customHeaders = [] }) => {
    // creating request headers
    const headers = (0, exports.createHeaders)(params, auth, disableAuth, customHeaders, responseType, jwtToken, authType, signal);
    // base url
    const baseUrl = resource ? (0, exports.isUrl)(resource) ? resource : resources ? resources[resource] || '' : '' : '';
    // complete url
    const completeUrl = !path ? baseUrl : `${baseUrl}${path}`;
    return body ? { url: completeUrl, headers, body } : { url: completeUrl, headers };
};
exports.resourcesBaseOperations = resourcesBaseOperations;
// Function to determine the axios method
const getAxiosRequest = async (method, url, headers, body) => {
    let response = null;
    switch (method) {
        case 'delete':
            // Axios delete options
            const deleteOptions = { ...headers, ...body };
            response = await axios_1.default.delete(url, deleteOptions);
            return response;
        case 'get':
            response = await axios_1.default.get(url, headers);
            return response;
        case 'post':
            response = await axios_1.default.post(url, body, headers);
            return response;
        case 'put':
            response = await axios_1.default.put(url, body, headers);
            return response;
        default:
            return response;
    }
};
// Function with HTTP request's HTTP method, url, headers and body passed as arguments, that returns an object with 'data' and 'error' keys
const executeRequest = async ({ fullResponse = false, method = 'get', url, headers, body = null, errorInterceptor = null }) => {
    // Base response object
    const baseResponse = { data: null, error: null };
    // Axios expects to have a body with a 'data' key for DELETE requests with the actual data to pass, so we need to add it if it's not there
    // const normalizedBody: string | IKeyStringMap | null = body ? body.data ? body.data : { ...body } : null
    try {
        const resourceResponse = await getAxiosRequest(method, url, headers, body);
        if (resourceResponse) {
            const { data: response, ...rest } = resourceResponse;
            if (response) {
                baseResponse.data = fullResponse ? { ...rest, data: response } : response.data ? response.data : response;
            }
        }
    }
    catch (error) {
        if (errorInterceptor && typeof errorInterceptor === 'function') {
            errorInterceptor(error);
        }
        console.log(error);
        baseResponse.error = error;
    }
    return baseResponse;
};
exports.executeRequest = executeRequest;
